// These should be kept in sync with the colors in the styleguide => _colors.scss
export const COLORS = {
  chartPurple: '#844ba8',
  chartLightPurple: '#e0d2e9',
  black: '#000000',
  blue: '#1374c9',
  borderGray: '#d8d8d8',
  darkGreen: '#0f4122',
  darkBlue: '#0c4c85',
  darkRed: '#6b140c',
  gray1: '#595959',
  gray2: '#919191',
  gray3: '#e5e5e5',
  gray4: '#f5f5f5',
  gray5: '#fafafa',
  green: '#1f8446',
  lightBlue: '#e7f1fa',
  lightBlue2: '#cce4f7',
  lightGreen: '#e8f2ec',
  lightOrange: '#fbf1e7',
  lightRed: '#fbe9e8',
  orange: '#dc7418',
  red: '#d72919',
  white: '#ffffff',
  yellow: '#fffba3',
};
